module.exports = {"id":"192774","name":"Kostas Manolas","rating":"84","photo":"./data/images/photos/1/192774.png","club":{"name":"AS Rome","logo":"./data/images/clubs/ASRome.png"},"positions":["DC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KostasManolas0.json
// module id = 2406
// module chunks = 0